<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Настройка уведомлений</h5>
      </div>
      <div class="card-body">
        <table v-if="ready" class="table table-hover table-sms table-bordered">
          <thead>
          <tr>
            <th rowspan="2" colspan="2">Склад</th>
            <th colspan="4" class="text-center">Статусы заявок</th>
          </tr>
          <tr>
            <th v-for="status in statuses">{{ status.title }}</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="store in stores">
            <tr v-for="(title, type, index) in types">
              <td v-if="index === 0" rowspan="2">{{ store.title }} ({{ store.id }})</td>
              <td>{{ title }}</td>
              <td v-for="(status) in statuses">
                <NotificationSelect :type="type" :value="storeSettings[store.id][type][status.status]" :onChange="(v) => storeSettings[store.id][type][status.status] = v"/>
              </td>
            </tr>
          </template>
          </tbody>
        </table>
        <div class="text-right">
          <LoadingButton
            title="Сохранить"
            :loading="loading"
            :onClick="saveRecords"
            className="btn btn-success"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationSelect from "@/views/admin/settings/stores/components/NotificationSelect";
import LoadingButton from "@/components/buttons/LoadingButton"
import api from "@/api"

export default {
  components: {
    NotificationSelect,
    LoadingButton,
  },
  data() {
    return {
      stores: [],
      loading: false,
      storeSettings: {},
      statuses: [
        {status: 1, title: 'Обработана'},
        {status: 2, title: 'Назначена'},
        {status: -3, title: 'Отказ у курьера'},
        {status: 3, title: 'Доставлена'},
      ],
      types: {
        runner: 'Курьер',
        supervisor: 'Контролер'
      },
      ready: false,
    }
  },
  computed: {
    $AllStores() {
      return this.$store.getters["platform/stores"];
    },
    $StoresNotificationSettings() {
      return this.$store.getters["platform/storeNotificationSettings"];
    },
  },
  mounted() {
    this.getStores();
  },
  methods: {
    async saveRecords() {
      if (this.loading) return;
      this.loading = true;
      const {data} = await api.post('settings/stores/notifications', {
        storeSettings: {...this.storeSettings}
      })
      if (data.success) {
        toastr['success']('Сохранено!', 'Успешно');
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.loading = false;
    },
    getStores() {
      const stores = Object.values(this.$AllStores).filter((s) => s.is_active && ![1, 2, 3, 10, 4].includes(s.id));
      const filteredStores = [this.$AllStores[3], this.$AllStores[10], this.$AllStores[4]];
      this.stores = [...filteredStores, ..._.orderBy(stores, 'short_title')];
      const storeSettings = {...this.$StoresNotificationSettings};
      this.stores.forEach((s) => {
        if (!storeSettings[s.id]) {
          storeSettings[s.id] = {};
          Object.keys(this.types).forEach((t) => {
            storeSettings[s.id][t] = {};
            this.statuses.forEach((ss) => {
              storeSettings[s.id][t][ss.status] = null;
            })
          })
        }
      })
      this.storeSettings = storeSettings;
      this.ready = true;
    }
  }
}
</script>
